import { apiGateway } from '../api';

async function adicionarPerfil(body) {
    try {
        const response = await apiGateway.post('/perfil/usuario/adicionar', body);
        return response;
    } catch (error) {
        return error.response.status;
    }
}

async function adicionarPerfilRH(body) {
    try {
        return await apiGateway.post('/perfil/usuario/adicionar/rh', body);
    } catch (error) {
        return error.response.status;
    }
}

async function consultarPerfil(body) {
    try {
        const response = await apiGateway.post('/perfil/usuario/consulta', body);
        return response.data;
    } catch (error) {
        return error.response.status;
    }
}

async function removerPerfil(body) {
    try {
        const response = await apiGateway.delete('/perfil/usuario/excluir', { data: body });
        return response;
    } catch (error) {
        return error.response.status;
    }
}

export { adicionarPerfil, adicionarPerfilRH, consultarPerfil, removerPerfil };
